import RoundedButton from '../buttons/RoundedButton'
import Modal from '@mui/material/Modal'

const TwoButtonsModal = (props) => {
    return (
        <Modal
            className='flex items-center justify-center'
            disableAutoFocus={true}
            open={props.open}
            onClose={props.onClose}
        >
            <div className='bg-white justify-center items-center mx-4 py-8 px-6 rounded-[0.625rem]'>
                <p className='font-montserrat text-xl font-bold text-center'>{props.title}</p>
                <p className='font-montserrat text-center mt-3'>{props.message}</p>
                
                <div className='flex flex-row justify-center mt-8 space-x-6'>
                    <div className='flex w-60'>
                        <RoundedButton 
                            onClick={props.onClose}
                            text={props.buttonText1}
                            height={48}
                            bgColor='#007EB4'
                        />
                    </div>

                    <div className='flex w-60'>
                        <RoundedButton 
                            onClick={props.onClick}
                            text={props.buttonText2}
                            height={48}
                            bgColor='#E85F5C'
                        />
                    </div>
                    
                </div>
            </div>
        </Modal>
    )
}

export default TwoButtonsModal